<template>
  <main-layout>
    <v-tabs v-model="view">
      <v-tab :href="'#Users'" ripple>
        Users
      </v-tab>
      <v-tab :href="'#Variables'" ripple>
        Variables
      </v-tab>
    </v-tabs>
    <component v-bind:is="componentView" />
  </main-layout>
</template>

<script>
import Users from './Users'
import Variables from './Variables'
export default {
  components: {
    Users
  },
  data() {
    return {
      view: 'Users'
    }
  },
  computed: {
    componentView() {
      const name = this.view
      return () => import(`./${name}`)
    }
  },
  mounted() {
    if (this.$route.query.tab) {
      this.view = this.$route.query.tab
    }
  },
  methods: {
    camelize(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return '' // or if (/\s+/.test(match)) for white spaces
        return index === 0 ? match.toLowerCase() : match.toUpperCase()
      })
    },
    updateRoute: function() {
      this.$router.push({
        query: {
          tab: this.view
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    view: function() {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytic/Main.vue